// PRD 05 §3.7 / §8.3 — delete confirmation modal. Two copy variants
// (main vs sub-question) live in the i18n catalog.
//
// The page level mounts a single instance and feeds it the qid + parent state
// of the row the user clicked.

import { useTranslation } from 'react-i18next';

import { ConfirmModal } from '@/components/feedback/ConfirmModal';

interface DeleteQuestionConfirmProps {
  open: boolean;
  isSub: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteQuestionConfirm({
  open,
  isSub,
  loading,
  onConfirm,
  onCancel,
}: DeleteQuestionConfirmProps) {
  const { t } = useTranslation('questionnaire-design');
  return (
    <ConfirmModal
      open={open}
      title={t('deleteConfirm.title')}
      message={
        isSub
          ? t('deleteConfirm.messageSub')
          : t('deleteConfirm.messageMain')
      }
      confirmLabel={t('deleteConfirm.confirm')}
      cancelLabel={t('deleteConfirm.cancel')}
      confirmVariant="destructive"
      loading={loading}
      loadingLabel={t('deleteConfirm.loadingLabel')}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
